import React, { useState, useEffect } from "react";
import { Spin } from "antd";
import { ErrorMessage, Field, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import {
  POST_CompanyInsertUpdateLicense,
  POST_GetCompanyLicenseHistory,
} from "../../../helpers/url_helper";
import { post, postFormData } from "../../../helpers/api_helper";
import { errorMessage, successMessage } from "../CommonFunctions";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";

const UpgradeLicence = () => {
  const [isLoading, setIsLoading] = useState(false);

  const [licenseHistoryList, setLicenseHistoryList] = useState([]);
  const [showLicenseUpdateModal, setShowLicenseUpdateModal] = useState(false);

  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));
  const formsList = AuthUser?.Permissions?.FormList;

  const getLicenseHistory = async () => {
    setIsLoading(true);
    await post(POST_GetCompanyLicenseHistory, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    })
      .then((response) => {
        setLicenseHistoryList(response?.LicenseHistList);
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getLicenseHistory();
  }, []);

  const validationSchema = Yup.object().shape({
    LicenseFile: Yup.string().trim().required("Licence File is required field"),
  });

  const formik = useFormik({
    validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      LicenseFile: "",
      LicenseFileKey: "",
    },
    validateOnBlur: false,
  });

  const {
    values: { LicenseFileKey },
  } = formik;

  const UpgradeLicense = () => {
    formik.resetForm();
    setShowLicenseUpdateModal(true);
  };

  const uploadLicenseFile = (e) => {
    if (e?.target?.files[0]) {
      const file = e?.target?.files[0];
      // var pattern = /(.appegic)$/;

      // if (!file.type.match(pattern)) {
      //   warningMessage("Select valid file!");
      //   formik.setFieldValue("LicenseFile", "");
      //   formik.setFieldValue(
      //     "LicenseFileKey",
      //     Math.random().toString(9).substring(2, 9)
      //   );
      // } else {
      formik.setFieldValue("LicenseFile", file);
      // }
    } else {
      formik.setFieldValue("LicenseFile", "");
      formik.setFieldValue(
        "LicenseFileKey",
        Math.random().toString(9).substring(2, 9)
      );
    }
  };

  const handleValidSubmit = async (values) => {
    setIsLoading(true);
    let formData = new FormData();
    formData.append(
      "CreatedByEncrypted",
      AuthUser?.ReferenceIDEncrypt ? AuthUser?.ReferenceIDEncrypt : "0"
    );
    formData.append("CompanyIDInputEncrypted", AuthUser?.CompanyIDEncrypt);
    formData.append("LicenseFile", values?.LicenseFile);
    await postFormData(POST_CompanyInsertUpdateLicense, formData)
      .then((response) => {
        if (response?.IsSuccess) {
          successMessage(response?.Message);
          setShowLicenseUpdateModal(false);
          getLicenseHistory();
        } else {
          errorMessage(response?.Message);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <div className="card m-1">
      <div className="card-body p-1">
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <div className="table-responsive active-projects style-1 shorting">
            <div className="tbl-caption p-2">
              <h4 className="heading mb-0">Upgrade Licence</h4>
              <div className="d-flex align-items-center">
                {AuthUser?.UserType !== 1 ||
                formsList?.filter((x) => x?.FormID == 45 && x?.IsEdit)?.length >
                  0 ? (
                  <button
                    type="button"
                    // className="btn btn-primary btn-sm me-2"
                    className="btn btn-outline-primary btn-sm"
                    onClick={() => {
                      UpgradeLicense();
                    }}
                  >
                    <i className="fa fa-shield"></i> Upgrade Licence
                  </button>
                ) : (
                  ""
                )}
              </div>
            </div>
            <hr className="mt-0 mb-1"></hr>
            <div className="p-2 pt-0 pb-0">
              <div
                id="LicenseHistory-tbl_wrapper"
                className="dataTables_wrapper no-footer"
              >
                <table
                  id="LicenseHistory-tbl"
                  className="table dataTable no-footer mb-0"
                >
                  <thead>
                    <tr>
                      <th width="8%">Sr No</th>
                      <th width="18%">Validity From</th>
                      <th width="16%">Validity To</th>
                      <th width="16%">No of Branch</th>
                      <th width="18%">No of Department</th>
                      <th width="24%" style={{ textAlign: "left" }}>
                        Created On
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {licenseHistoryList?.length > 0 ? (
                      licenseHistoryList?.map((item, indx) => (
                        <tr>
                          <td>{item.SrNo}</td>
                          <td>{item.ValidityFromDate}</td>
                          <td>{item.ValidityToDate}</td>
                          <td>{item.NoOfBranch}</td>
                          <td>{item.NoOfDepartment}</td>
                          <td style={{ textAlign: "left" }}>
                            {item.CreatedOn}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={6} style={{ textAlign: "left" }}>
                          <div>{"No Record Found..."}</div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </Spin>
        <Modal
          className="fade"
          show={showLicenseUpdateModal}
          onHide={setShowLicenseUpdateModal}
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <FormikProvider value={formik}>
              <Form onSubmit={formik.handleSubmit}>
                <Modal.Header>
                  <Modal.Title>Upgrade Licence</Modal.Title>
                  <Button
                    type="button"
                    variant=""
                    className="btn-close"
                    onClick={() => setShowLicenseUpdateModal(false)}
                  ></Button>
                </Modal.Header>
                <Modal.Body>
                  <Row>
                    <Col lg={12}>
                      <div className="mb-2">
                        <label className="mb-1">Licence File</label>
                        <input
                          type="file"
                          className="form-control form-control-sm"
                          id="LicenseFile"
                          key={LicenseFileKey || ""}
                          onChange={(e) => {
                            uploadLicenseFile(e);
                          }}
                          autoFocus
                        />
                        <ErrorMessage
                          name="LicenseFile"
                          component="div"
                          className="invalid-feedback animated fadeInUp"
                          style={{ display: "block" }}
                        />
                      </div>
                    </Col>
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    // variant="primary"
                    variant="primary btn-sm"
                    type="submit"
                  >
                    <i className="fa-solid fa-floppy-disk"></i> Submit
                  </Button>
                  <Button
                    // variant="danger light"
                    variant="danger btn-sm"
                    onClick={() => setShowLicenseUpdateModal(false)}
                  >
                    <i className="fa fa-cancel"></i> Cancel
                  </Button>
                </Modal.Footer>
              </Form>
            </FormikProvider>
          </Spin>
        </Modal>
      </div>
    </div>
  );
};

export default UpgradeLicence;
